"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToolTipAttr = exports.getAttr = exports.getArrowHeight = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable indent */
var getArrowHeight = exports.getArrowHeight = function getArrowHeight(side) {
  // return Math.ceil(Math.sqrt(2 * side * side) / 2);
  return Math.floor(side / 2);
};
var getToolTipAttr = exports.getToolTipAttr = function getToolTipAttr(_ref) {
  var position = _ref.position,
    appearanceConfig = _ref.appearanceConfig,
    variant = _ref.variant,
    tooltipContainerRef = _ref.tooltipContainerRef,
    tooltipRef = _ref.tooltipRef;
  var tooltipContainerRect = {};
  var tooltipRect = {};
  if (tooltipContainerRef.current && tooltipRef.current) {
    tooltipContainerRect = tooltipContainerRef.current.getBoundingClientRect();
    tooltipRect = tooltipRef.current.getBoundingClientRect();
  }
  var styles = {};
  styles.arrow = {};
  var arrowHeight = getArrowHeight(variant.size.arrow);
  styles.arrow.height = styles.arrow.height = variant.size.arrow;
  styles.arrowSize = variant.size.arrow;
  var mobileBottomStyles = {
    arrowMobileTop: "-".concat(arrowHeight / 10, "rem"),
    arrowMobileLeft: "".concat(variant.size.arrow / 10, "rem"),
    arrowMobileRight: "unset",
    arrowMobileBorderColor: "".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor, " transparent transparent")
  };
  var mobileBottomRStyles = {
    arrowMobileTop: "-".concat(arrowHeight / 10, "rem"),
    arrowMobileLeft: "unset",
    arrowMobileRight: "".concat(variant.size.arrow / 10, "rem"),
    arrowMobileBorderColor: "".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor, " transparent transparent")
  };
  var topStyles = {
    arrowTop: "calc(100% - ".concat(arrowHeight / 10, "rem)"),
    arrowLeft: "".concat(arrowHeight * 2 / 10, "rem"),
    arrowRight: "unset",
    arrowBorderColor: "transparent transparent ".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor),
    tooltipTop: "".concat((tooltipContainerRect.top - tooltipRect.height - arrowHeight) / 10, "rem"),
    tooltipLeft: "".concat(tooltipContainerRect.left / 10, "rem"),
    tooltipMarginLeft: "-".concat(Math.floor(variant.minWidth / 20), "rem"),
    arrowMobileTop: "calc(100% - ".concat(arrowHeight / 10, "rem)"),
    arrowMobileLeft: "".concat(arrowHeight * 2 / 10, "rem"),
    arrowMobileRight: "unset",
    arrowMobileBorderColor: "transparent transparent ".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor)
  };
  var bottomStyles = _objectSpread({
    arrowTop: "-".concat(arrowHeight / 10, "rem"),
    arrowLeft: "".concat(variant.size.arrow / 10, "rem"),
    arrowRight: "unset",
    arrowBorderColor: "".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor, " transparent transparent"),
    tooltipMarginLeft: "-".concat(Math.floor(variant.minWidth / 20), "rem"),
    tooltipTop: "".concat((tooltipContainerRect.top + tooltipContainerRect.height + arrowHeight) / 10, "rem"),
    tooltipLeft: topStyles.tooltipLeft
  }, mobileBottomStyles);
  var leftStyles = _objectSpread({
    arrowTop: "".concat(arrowHeight * 3 / 10, "rem"),
    arrowLeft: "unset",
    arrowRight: "-".concat(arrowHeight / 10, "rem"),
    arrowBorderColor: "transparent ".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor, " transparent"),
    tooltipLeft: "".concat((tooltipContainerRect.left - arrowHeight - tooltipRect.width) / 10, "rem"),
    tooltipTop: "".concat((tooltipContainerRect.top - tooltipContainerRect.height) / 10, "rem"),
    tooltipMobileTop: bottomStyles.tooltipTop,
    tooltipMobileLeft: bottomStyles.tooltipLeft
  }, mobileBottomStyles);
  var rightStyles = _objectSpread({
    arrowTop: "calc(".concat(arrowHeight * 3 / 10, "rem)"),
    arrowLeft: "-".concat(arrowHeight / 10, "rem"),
    arrowRight: "unset",
    arrowBorderColor: "".concat(appearanceConfig.borderColor, " transparent transparent").concat(appearanceConfig.borderColor),
    tooltipLeft: "".concat((tooltipContainerRect.left + tooltipContainerRect.width + arrowHeight) / 10, "rem"),
    tooltipTop: leftStyles.tooltipTop,
    tooltipMobileTop: bottomStyles.tooltipTop,
    tooltipMobileLeft: bottomStyles.tooltipLeft
  }, mobileBottomStyles);
  var bottomRightStyles = _objectSpread({
    arrowTop: "-".concat(arrowHeight / 10, "rem"),
    arrowLeft: "unset",
    arrowRight: "".concat(variant.size.arrow / 10, "rem"),
    arrowBorderColor: "".concat(appearanceConfig.borderColor, " ").concat(appearanceConfig.borderColor, " transparent transparent"),
    tooltipMarginLeft: "-".concat(Math.floor(variant.minWidth / 20), "rem"),
    tooltipTop: bottomStyles.tooltipTop,
    tooltipLeft: bottomStyles.tooltipLeft
  }, mobileBottomRStyles);
  var positionStyles = {
    topStyles: topStyles,
    bottomStyles: bottomStyles,
    leftStyles: leftStyles,
    rightStyles: rightStyles,
    bottomRightStyles: bottomRightStyles
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), positionStyles["".concat(position, "Styles")]), appearanceConfig), variant), {}, {
    arrowHeight: arrowHeight + 2
  });
};
var getAttr = exports.getAttr = function getAttr(key) {
  return function (props) {
    return getToolTipAttr(props)[key];
  };
};